import { getFeatureUsages } from '@modusign/openapi-client-subscription';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import {
  USER_AUTHORITY__FETCH_FAILURE,
  USER_AUTHORITY__FETCH_REQUEST,
  USER_AUTHORITY__FETCH_SUCCESS,
  USER_AUTHORITY__INITIALIZE,
  USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_FAILURE,
  USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_REQUEST,
  USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_SUCCESS,
} from '@app/store/actionTypes';
import UserAuthority from '@app/store/user/authority/UserAuthority';

/**
 * 유저 권한 및 제한에 대해 조회한다.
 */
export function fetchUserAuthorityPermissionsAndLimits() {
  return {
    type: USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_REQUEST,
  };
}

/**
 * 유저 권한 및 제한에 대해 조회 성공을 알린다.
 */
export function fetchUserAuthorityPermissionsAndLimitsSuccess(
  payload: Omit<UserAuthority, 'usages'> | null
) {
  return {
    type: USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_SUCCESS,
    payload,
  };
}

/**
 * 유저 권한 및 제한에 대해 조회 실패를 알린다.
 */
export function fetchUserAuthorityPermissionsAndLimitsFailure(error: Error) {
  return {
    type: USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_FAILURE,
    payload: error,
    error: true,
  };
}

export const checkSigningRequestAuthority = createAsyncThunk(
  'contractSetup/checkSigningRequestAuthority',
  async (payload: { workspaceId: string }, { dispatch, rejectWithValue, fulfillWithValue }) => {
    try {
      const data = await getFeatureUsages(payload.workspaceId);
      dispatch(fetchUserAuthoritySuccess(data));
      fulfillWithValue(data);
    } catch (error) {
      dispatch(fetchUserAuthorityFailure(error));
      rejectWithValue(error);
    }
  }
);

/**
 * 유저 기능 권한 및 제한, 사용량에 대해 조회한다.
 */
export function fetchUserAuthority() {
  return {
    type: USER_AUTHORITY__FETCH_REQUEST,
  };
}

/**
 * 유저 기능 권한 및 제한, 사용량에 대해 조회 성공을 알린다.
 */
export function fetchUserAuthoritySuccess(payload: UserAuthority | null) {
  return {
    type: USER_AUTHORITY__FETCH_SUCCESS,
    payload,
  };
}

/**
 * 유저 기능 권한 및 제한, 사용량에 대해 조회 실패를 알린다.
 */
export function fetchUserAuthorityFailure(error: AxiosError) {
  return {
    type: USER_AUTHORITY__FETCH_FAILURE,
    payload: error,
    error: true,
  };
}

/**
 * 유저 권한 및 사용 가능한 기능과 기능 사용량에 대한 상태를 초기화한다.
 */
export function initializeUserAuthority() {
  return {
    type: USER_AUTHORITY__INITIALIZE,
  };
}

export type UserAuthorityAction =
  | ReturnType<typeof fetchUserAuthorityPermissionsAndLimits>
  | ReturnType<typeof fetchUserAuthorityPermissionsAndLimitsSuccess>
  | ReturnType<typeof fetchUserAuthorityPermissionsAndLimitsFailure>
  | ReturnType<typeof fetchUserAuthority>
  | ReturnType<typeof fetchUserAuthoritySuccess>
  | ReturnType<typeof fetchUserAuthorityFailure>
  | ReturnType<typeof initializeUserAuthority>;
